import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    Alert,
    FlatList,
    Image,
    ImageBackground,
    TextProps, ViewProps
} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import { RouteProp } from '@react-navigation/native';
import AppText from "./AppText";
import HideableView from "./HideableView";
import SubClientItem from "./SubClientItem";


type ProjectsScreenNavigationProp = StackNavigationProp< any, 'Projects'>;
interface IProps {
    courier:any;
    removeCallBack:Function;
}
interface IState {
    isInfoOpened:boolean;
    isAddOpened:boolean;
}

export default class CourierItem extends React.Component<IProps & ViewProps> {

    state:IState={
        isInfoOpened:false,
        isAddOpened:false
    }
    componentDidMount() {

    }

    render() {
        return(
            <View style={{width:'100%',borderBottomColor:'grey',paddingTop:10,paddingBottom:this.state.isInfoOpened?0:10,borderWidth:1,alignItems:'center'}}>
                <View style={{flexDirection:'row',justifyContent:'center',alignItems:'center',paddingLeft:15,paddingRight:15}}>
                    <View style={{flex:0.28,alignItems:'flex-start'}}>
                        <AppText style={{color:'black',fontSize:12,fontWeight:'700'}}>{this.props.courier.name}</AppText>
                    </View>
                    <View style={{flex:0.18,alignItems:'flex-start'}}>
                        <AppText style={{color:'black',fontSize:12}}>{this.props.courier.area}</AppText>
                    </View>
                    <View style={{flex:0.24,alignItems:'flex-start'}}>
                        <AppText style={{color:'black',fontSize:12}}>{this.props.courier.phone}</AppText>
                    </View>
                    <View style={{flex:0.18,alignItems:'flex-start'}}>
                        <AppText style={{color:'black',fontSize:12,marginLeft:15}}>{this.props.courier.licenseType}</AppText>
                    </View>
                    <View style={{flex:0.13,alignItems:'center'}}>
                        <TouchableOpacity onPress={()=>this.props.removeCallBack(this.props.courier)} style={{height:20,width:20,borderRadius:20,backgroundColor:'#019FB2',justifyContent:'center',alignItems:'center'}}>
                            <AppText style={{color:'white',fontSize:15,fontWeight:'500'}}>X</AppText>
                        </TouchableOpacity>
                    </View>
                </View>

            </View>
        );
    }
}

